import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './ForwardStepType.module.scss';
import withInspector from 'fulogics-ui-web/dist/layout/inspector/hoc/withInspector';

import ForwardStepTypeSchema from './ForwardStepTypeSchema';
import { IdType } from 'fulogics-ui-core/dist/api/models/IdType';
import { enTMSItemType } from 'fulogics-ui-core/dist/api/models/enums/TMSSystem/enTMSItemType';

const ForwardStepType = ({
    data,
    showPayload,
    onPayloadClick,
    className,
}: ForwardStepTypeProps) => {
    const { t } = useTranslation('ForwardStepType');

    const handlePayloadClick = useCallback(() => {
        onPayloadClick && onPayloadClick(data);
    }, [onPayloadClick]);

    return (
        <div className={classNames(styles.container, className)}>
            {data?.type ? <div>{t(`type.${data?.type}`)}</div> : '-'}
            {showPayload && !!data?.payload?.carrierCount && (
                <label className={classNames(styles.payload)} onClick={handlePayloadClick}>
                    {t('carrier', {
                        count: data?.payload?.carrierCount,
                    })}
                </label>
            )}
        </div>
    );
};

export type ForwardStepTypeProps = {
    data?: ForwardStepTypeData;
} & ForwardStepTypeDisplayOptions;

export default withInspector<ForwardStepTypeProps>(ForwardStepType, ForwardStepTypeSchema);

export class ForwardStepTypeDisplayOptions {
    id?: string;
    className?: string;
    showPayload?: boolean;
    //
    onPayloadClick?: (data?: ForwardStepTypeData) => void;
}

export type ForwardStepTypeData = {
    id?: IdType;
    payload?: {
        carrierCount?: number;
    };
    type?: enTMSItemType;
};
export const ForwardStepTypeDataKeys = ['type', 'payload.carrierCount'];
